import { kebabCase, map } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatResource } from '../../../common/helpers/localization/contentResourceHelper';
import dateTimeHelper from '../../../common/helpers/ui/DateTimeHelper';
import { contentPageTitle } from '../../../common/helpers/ui/pageTitleMetaDescription';
import contentResource from '../../../locales/th/content.json';
import ShareItems from '../../share/ShareItems';
import { Info, InfoAndShareWrapper, TitleWrapper } from './ContentTitle.style';
import { WholeState } from '../../../store/common/type';

interface Author {
  name: string;
  link: string;
}
interface PostData {
  title: string;
  postCategory?: string;
  date?: string;
  author?: Author;
  propertyType?: string[];
}
interface PostTitleProps {
  postingData: PostData;
  asPath: string;
}
const PostTitle: React.FC<PostTitleProps> = ({ postingData, asPath }) => {
  const articleByText = formatResource(contentResource.articleBy, {});
  const { author = { name: '', link: '' }, propertyType = [] } = postingData;
  const xago = dateTimeHelper.getHumanizeDiff(postingData.date) || '';
  const seoTitle = contentPageTitle(
    postingData.title,
    postingData.postCategory,
  );
  const deviceType = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.deviceType : 'desktop',
  );

  return (
    <TitleWrapper data-test={'content-title'}>
      <h1 className="review-title">{postingData.title}</h1>
      <InfoAndShareWrapper deviceType={deviceType}>
        <Info>
          {articleByText}: <a href={author.link}>{author.name}</a> | {xago} |{' '}
          <span>
            {map(propertyType, (item, i) => [
              i > 0 && ', ',
              <a href={`/${kebabCase(item)}`} key={i}>
                {item}
              </a>,
            ])}
          </span>
        </Info>
        <ShareItems asPath={asPath} title={seoTitle} deviceType={deviceType} />
      </InfoAndShareWrapper>
    </TitleWrapper>
  );
};

export default PostTitle;
